/**
 * Aspect — Session 2D tour (browser localStorage)
 * --------------------------------------------------------------
 * Production SampleTour keeps the uploaded apartment in this tab's storage so
 * a refresh does not snap back to the shared default. Only Reset clears it.
 */

const STORAGE_KEY = "aspect-session-tour-v1";

/** Drop catalog (too large for localStorage) and keep the rebuilt home. */
export function slimSessionTour(state) {
  if (!state?.room) return null;
  return {
    sandbox: true,
    room: state.room,
    placements: Array.isArray(state.placements) ? state.placements : [],
    version: Number(state.version) || Date.now(),
    syncId: state.syncId ?? "session",
    ...(state.totalCost != null ? { totalCost: state.totalCost } : {}),
  };
}

export function loadSessionTour() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data?.room ? data : null;
  } catch {
    return null;
  }
}

export function saveSessionTour(state) {
  const slim = slimSessionTour(state);
  if (!slim) return false;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(slim));
    return true;
  } catch {
    return false;
  }
}

export function clearSessionTour() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function hasSessionTour() {
  return Boolean(loadSessionTour()?.room);
}

export default { loadSessionTour, saveSessionTour, clearSessionTour, hasSessionTour, slimSessionTour };
